import { useState } from "react";
import {loginRequest} from "../api/api";
import {useApp} from "../Contex";

export default function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const {setToken, setUserName, setSid} = useApp();

    function handleLogin() {
        loginRequest(email, password).then((res) => {
            if (res.ok) {
                if(res.sid){
                    setSid(res.sid)
                }else{
                    setUserName(email);
                }
                setToken(res.token);
            } else {
                setError(res.error); // Set the actual error message
            }
        });
    }

    return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <div className="card p-4" style={{ width: "100%", maxWidth: "400px" }}>
                <h3 className="mb-3 m-auto">QR-ADMIN</h3>
                {error && (
                    <div className="bg-danger-subtle border border-danger rounded p-2 mb-3" role="alert">
                        {error}
                    </div>
                )}

                <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input
                        id="email"
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => {
                            setError(null)
                            setEmail(e.target.value)
                        }}
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input
                        id="password"
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => {
                            setError(null)
                            setPassword(e.target.value)
                        }}
                    />
                </div>
                <button className="btn btn-warning w-100" onClick={handleLogin}>
                    Login
                </button>
            </div>
        </div>
    );
}
